export default __webpack_public_path__ + "static/media/garden1.56114cf3.png";